import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

// Guia do LADO RH (19/09/2026). Nasceu de uma IA externa que, perguntada sobre o eaiRH, escreveu sozinha
// modelos de feedback e dicas de como responder a um relato — conteúdo que não existia aqui. Publicado por nós,
// revisado para bater com o produto de verdade (e SEM a dica que ela deu de "pedir avaliações para diluir
// reclamações", que é exatamente o jogo que a nota por taxa existe para impedir).
// O SeoMeta.cs injeta o mesmo conteúdo no HTML do servidor para o crawler.

function Modelo({ titulo, texto }) {
  const [copiado, setCopiado] = useState(false);
  const copiar = () => {
    try { navigator.clipboard.writeText(texto); setCopiado(true); setTimeout(() => setCopiado(false), 2000); } catch { /* sem clipboard */ }
  };
  return (
    <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">
      <div className="flex items-center justify-between gap-3 border-b border-gray-100 px-5 py-3">
        <h3 className="font-semibold text-gray-900">{titulo}</h3>
        <button type="button" onClick={copiar}
          className="shrink-0 rounded-lg border border-gray-300 px-3 py-1 text-sm font-medium text-gray-700 hover:bg-gray-50">
          {copiado ? "Copiado ✓" : "Copiar"}
        </button>
      </div>
      <pre className="whitespace-pre-wrap px-5 py-4 text-sm text-gray-700 font-sans leading-relaxed">{texto}</pre>
    </div>
  );
}

const REGUA = [
  ["Inscrição", "Confirme o recebimento e diga até quando a triagem termina.", "no mesmo dia"],
  ["Triagem", "Quem não segue recebe um encerramento educado — pode ser automático, mas precisa chegar.", "até o fim da triagem"],
  ["Entrevista ou teste", "Diga ali, na hora, o prazo do retorno. E cumpra — positivo ou negativo.", "prazo combinado (ex.: 5 dias úteis)"],
  ["Etapa final", "Reprovação depois de entrevista pede retorno escrito e pessoal, com o motivo principal.", "até 5 dias úteis"],
];

const EMAIL_REPROVACAO = `Assunto: Retorno sobre o processo seletivo — [Vaga]

Olá, [Nome], tudo bem?

Obrigado pelo tempo que você dedicou ao nosso processo seletivo para a vaga de [Vaga].

Concluímos esta etapa e decidimos seguir com um perfil com mais experiência em [principal motivo real — ex.: a ferramenta X / o tipo de projeto Y].

Um ponto forte que percebemos em você: [ponto real da entrevista ou do currículo].

Se quiser um retorno mais detalhado sobre a sua participação, é só responder a este e-mail.

Obrigado mais uma vez e sucesso na sua caminhada.

[Seu nome] — [Empresa]`;

const STATUS_ATRASO = `Oi, [Nome], tudo bem?

Combinamos que eu te daria um retorno até hoje sobre a vaga de [Vaga]. Ainda estou aguardando a avaliação final da área, e não queria te deixar sem notícia.

A previsão é ter a resposta até [nova data]. Assim que tiver, te aviso — seja qual for.

Obrigado pela paciência!`;

const COBRANCA_GESTOR = `Olá, [Gestor],

As entrevistas da vaga de [Vaga] foram em [data] e os candidatos estão aguardando retorno.

Preciso da sua decisão sobre quem segue (e do motivo principal de quem não segue) até [data limite], para respondermos a todos dentro do prazo que combinamos com eles.

Candidato sem retorno vira relato público — e isso pesa na atração das próximas vagas da sua própria área.

Obrigado!`;

export default function GuiaRhPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />

      <section className="bg-brand text-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <span className="inline-block rounded-full bg-white/10 border border-white/20 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-orange-200">
            Guia eaiRH · RH e recrutadores
          </span>
          <h1 className="text-3xl md:text-5xl font-extrabold mt-4 leading-tight">
            Como dar <span className="text-orange-400">retorno ao candidato</span> — e responder a um relato
          </h1>
          <p className="mt-4 text-lg text-white/90 max-w-2xl">
            A régua de retorno por etapa, modelos prontos para copiar e o que fazer quando um relato sobre a sua empresa aparece no eaiRH.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link to="/empresas" className="rounded-xl bg-orange-600 hover:bg-orange-700 px-6 py-3 font-semibold">Ver a página da minha empresa</Link>
            <Link to="/para-empresas" className="rounded-xl bg-white/15 hover:bg-white/25 px-6 py-3 font-semibold">eaiRH para empresas</Link>
          </div>
        </div>
      </section>

      <main className="max-w-3xl mx-auto px-4 md:px-6 py-12 space-y-14">
        <section>
          <h2 className="text-2xl md:text-3xl font-bold text-text">Por que o retorno importa</h2>
          <p className="text-gray-600 mt-3">
            Nos processos seletivos relatados no eaiRH, <strong>cerca de 9 em cada 10 terminaram sem nenhum retorno</strong> ao candidato.
            Quase nunca é má-fé: é volume, gestor que não decide e ferramenta que não avisa. Mas, para quem ficou esperando, o efeito é o mesmo — e ele aparece na reputação da empresa.
          </p>
          <p className="text-gray-600 mt-3">
            A boa notícia: retorno é a coisa mais barata de consertar em recrutamento. Não exige ferramenta nova; exige um prazo dito em voz alta e cumprido.
          </p>
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold text-text">A régua de retorno por etapa</h2>
          <div className="mt-5 space-y-3">
            {REGUA.map(([etapa, oque, prazo]) => (
              <div key={etapa} className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
                <div className="flex flex-wrap items-baseline justify-between gap-2">
                  <h3 className="font-bold text-gray-900">{etapa}</h3>
                  <span className="text-xs font-semibold text-primary">{prazo}</span>
                </div>
                <p className="text-sm text-gray-600 mt-1">{oque}</p>
              </div>
            ))}
          </div>
          <p className="text-sm text-gray-500 mt-3">A regra de ouro: <strong>quanto mais o candidato investiu, mais pessoal precisa ser o retorno.</strong> Triagem aceita mensagem automática; entrevista, não.</p>
        </section>

        <section className="space-y-4">
          <h2 className="text-2xl md:text-3xl font-bold text-text">Modelos prontos</h2>
          <Modelo titulo="E-mail de reprovação depois de entrevista" texto={EMAIL_REPROVACAO} />
          <Modelo titulo="Quando o prazo vai vencer e a área ainda não decidiu" texto={STATUS_ATRASO} />
          <Modelo titulo="Cobrança interna ao gestor da vaga" texto={COBRANCA_GESTOR} />
        </section>

        <section>
          <h2 className="text-2xl md:text-3xl font-bold text-text">Um relato sobre a sua empresa apareceu. E agora?</h2>
          <ul className="mt-4 space-y-3 text-gray-700">
            <li>✅ <strong>Responda no próprio eaiRH.</strong> A resposta é pública, gratuita e fica ao lado do relato — e o índice de resposta da empresa sobe.</li>
            <li>✅ <strong>Resolva antes de responder.</strong> Se o problema foi falta de retorno, mande o retorno para o candidato e depois conte isso na resposta.</li>
            <li>✅ <strong>Seja específico e humano.</strong> "Houve um atraso na decisão da área e já enviamos seu retorno por e-mail" vale mais que um texto padrão.</li>
            <li>❌ <strong>Não use resposta pronta</strong> do tipo "agradecemos seu feedback, estamos revisando nossos processos". Ela diz a quem lê que ninguém olhou o caso.</li>
            <li>❌ <strong>Não tente descobrir quem é o candidato</strong> de um relato anônimo. O anonimato é escolha dele e é protegido.</li>
          </ul>
          <p className="text-gray-600 mt-4">
            Depois da resposta, o candidato pode dar uma réplica e avaliar como foi a solução. <strong>Relato não se remove pagando</strong> — o que muda a reputação é dar retorno e responder.
            Veja <Link to="/como-funciona" className="text-primary underline">como a nota é calculada</Link> e os critérios do <Link to="/selo" className="text-primary underline">Selo eaiRH</Link>.
          </p>
        </section>

        <section className="rounded-2xl bg-text text-white p-6 md:p-8">
          <h2 className="text-2xl font-bold">Sua empresa ainda não tem conta?</h2>
          <p className="text-white/80 mt-2">Responder a relatos e publicar vagas é gratuito, sem plano e sem limite.</p>
          <Link to="/para-empresas" className="inline-block mt-4 rounded-xl bg-orange-600 hover:bg-orange-700 px-6 py-3 font-semibold">Conhecer o eaiRH para empresas</Link>
        </section>
      </main>
    </div>
  );
}
